import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { getButtonColor, getButtonVariant } from "../../../../../SiteNav/helpers.js";
/* empty css             */
const Buttons = ({ active, items }) => {
  if (!items || !items.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "site-nav-mobile__buttons" }, items.map((item) => /* @__PURE__ */ React.createElement(
    Button,
    {
      key: item.label,
      "data-t": item.label,
      icon: item.parameters && item.parameters.icon,
      href: item.link && item.link.href,
      caption: item.label,
      variant: getButtonVariant(item),
      color: getButtonColor(item),
      tabIndex: active ? void 0 : -1
    }
  )));
};
export {
  Buttons as default
};
//# sourceMappingURL=Buttons.js.map
